import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import Login from './components/Login';
import Signup from './components/Signup';
import Dashboard from './components/Dashboard';
import AdminPanel from './components/AdminPanel';
import LandingPage from './components/LandingPage';
import CustomerPortal from './components/CustomerPortal';
import ValetCheckIn from './components/ValetCheckIn';
import Checkout from './components/Checkout';

const ProtectedRoute = ({ children, adminOnly = false }) => {
    const { user, loading } = useContext(AuthContext);

    if (loading) {
        return <div className="loading-screen">Loading Parking 2.0...</div>;
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (adminOnly && !['admin', 'org_admin'].includes(user.role)) {
        return <Navigate to="/" replace />;
    }

    return children;
};

const ThemeWrapper = ({ children }) => {
    const { user } = useContext(AuthContext);
    
    useEffect(() => {
        if (user && user.dark_mode) {
            document.documentElement.setAttribute('data-theme', 'dark');
        } else {
            document.documentElement.removeAttribute('data-theme');
        }
    }, [user]);

    return children;
};

const AppContent = () => {
    return (
        <ThemeWrapper>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/pay/:orgName" element={<CustomerPortal />} />
                <Route path="/checkout/:purchaseId" element={<Checkout />} />
                <Route path="/" element={<LandingPage />} />
                <Route 
                    path="/dashboard" 
                    element={
                        <ProtectedRoute>
                            <Dashboard />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/admin" 
                    element={
                        <ProtectedRoute adminOnly={true}>
                            <AdminPanel />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/valet" 
                    element={
                        <ProtectedRoute>
                            <ValetCheckIn />
                        </ProtectedRoute>
                    } 
                />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </ThemeWrapper>
    );
};

function App() {
    return (
        <AuthProvider>
            <Router>
                <AppContent />
            </Router>
        </AuthProvider>
    );
}

export default App;